import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { switchLanguage } from '../../../../../actions/userAccount/user/switchLanguage'
import { CountryCode } from '../../../../../i18n/countryCodes'
import { IStore } from '../../../../../reducers'
import { getSelectedLanguage } from '../../../../../reducers/userAccount/selectors/userLanguage'
import {
  IClassName,
  ILanguageSwitcherDispatch,
  ILanguageSwitcherProps,
} from './LanguageSwitcher'

function mapStateToProps(state: IStore): ILanguageSwitcherProps {
  return {
    selectedLanguage: getSelectedLanguage(state),
  }
}

function bindDispatchToProps(dispatch: Dispatch): ILanguageSwitcherDispatch {
  return {
    switchLanguage(countryCode: CountryCode) {
      return function() {
        dispatch(switchLanguage(countryCode))
      }
    },
  }
}

export default connect<ILanguageSwitcherProps,
  ILanguageSwitcherDispatch,
  IClassName>(
  mapStateToProps,
  bindDispatchToProps,
)
